const state = {
	overlays: {},
	pageWrapStyle: {
		position: '',
		top: '',
		left: '',
	},
	lastScrollY: window.pageYOffset,
};

export default state;



// WEBPACK FOOTER //
// ./scripts/sky-overlay/store/state.js